import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { isEmpty } from '../../utils/obj-utils';

function TheOneClubFAQ({ title, questions }) {
    function displayQuestions() {
        if (isEmpty(questions)) {
            return null;
        }

        return questions.map((question, index) => {
            const checkId = `chk${index}`;
            return <div
                key={uniqueId()}
                className='tab'>
                <input type='checkbox' id={checkId} />
                <label className='tab-label' htmlFor={checkId}>{question.label}</label>
                <div className='tab-content' dangerouslySetInnerHTML={{ __html: question.description }}></div>
            </div>;
        });
    }

    return (
        <div className='faq'>
            <h2>{title}</h2>
            <div className='tabs'>
                {displayQuestions()}
            </div>
        </div>
    );
}

TheOneClubFAQ.propTypes = {
    title: PropTypes.string.isRequired,
    questions: PropTypes.array.isRequired
};

export default TheOneClubFAQ;
